(function() {
	'use strict';

	angular
		.module('dat.shared-components.common')
		.directive('datMaskingOverlay', datMaskingOverlay)
		.controller('MaskingOverlayCtrl', MaskingOverlayCtrl);

	function datMaskingOverlay() {
		var directive = {
			restrict: 'EA',
			replace: true,
			scope: {
				toggleDisplay: '=',
				showSpinner: '@',
				largeSpinner: '@'
			},
			template: '<div class="fader-animation" ng-show="toggleDisplay"></div>',
			controller: 'MaskingOverlayCtrl',
			controllerAs: 'ctrl'
		};

		return directive;
	}

	MaskingOverlayCtrl.$inject = ['$scope', '$element'];

	function MaskingOverlayCtrl($scope, $element) {

		activate();

		////////////////////

		function activate() {
			if ($scope.showSpinner) {
				if ($scope.largeSpinner) {
					$element.addClass('overlay-spinner-large');
				}
				else {
					$element.addClass('overlay-spinner');
				}  
			}
			else {
				$element.addClass('overlay');
			}

			if (!$scope.toggleDisplay) {
				$scope.toggleDisplay = true;
			}
		}
	}

})();
